import { render, staticRenderFns } from "./TwPreviewJsonChild.vue?vue&type=template&id=2b64e7b6&"
import script from "./TwPreviewJsonChild.vue?vue&type=script&lang=js&"
export * from "./TwPreviewJsonChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports